import * as React from 'react';
import { Dropdown, Menu, MenuItemProps, message } from 'antd';
import { RobotOutlined } from '@ant-design/icons';
import { GenerationTag, GenerationLevel, GenerationTextType, API } from '@config/index';
import { ItemType } from 'antd/lib/menu/hooks/useItems';
import { ParameterMapStore, getFullName } from '@lib/index';
import { ParameterConfig, ParameterType } from '@interface/parameter';
import { isEqual } from 'lodash';
import { defaultState, intentModel, StateInfo } from '@reducer/intent';

export type CommentPayload = {
  comment: string;
  ideId: string;
  typeName: string;
  parameters?: string;
};

function textGenerator({
  level, type, tag, onSelect, commentPayload
}: {
  level: GenerationLevel;
  type: GenerationTextType;
  tag?: GenerationTag;
  commentPayload?: CommentPayload;
  onSelect: (selected: string) => void;
}) {

  const [items, setItems] = React.useState<ItemType[]>([]);
  const [$ref, setRef] = React.useState<any>(undefined);
  const [haveCache, setHavCache] = React.useState<boolean>(false);
  const [cache, setCache] = React.useState<string[]>([]);
  const [cachedParams, setCachedParams] = React.useState<string>('');
  const [open, setOpen] = React.useState<boolean>(false);
  const [loading, setLoading] = React.useState<boolean>(false);

  const getItem = (str: string) => {

    return {
      label: str,
      key: str
    };
  };

  const callback = (e: any) => {
    if (!open) {
      return;
    }

    if (!$ref.contains(e.target)) {
      setOpen(false);
    }
  };

  React.useEffect(() => {

    document.addEventListener('click', callback);
    return () => {
      document.removeEventListener('click', callback);
    };
  });

  return <></>;

  // return (
  //   <div
  //     ref={(ref: any) => {
  //       setRef(ref);
  //     }}
  //   >
  //     <Dropdown
  //       trigger={['click']}
  //       open={open}
  //       placement="bottomRight"
  //       menu={{
  //         items,
  //         onClick: (info: any) => {
  //           setOpen(false);
  //           onSelect(parseSelected(type, info.key, cachedParams));
  //         }
  //       }}>
  //       <RobotOutlined
  //         title="Auto-generation"
  //         spin={loading}
  //         onClick={() => {
  //           if (open) {
  //             setOpen(false);
  //             return;
  //           }

  //           const params = type === GenerationTextType.Code
  //             ? commentPayload
  //             : getParams(level, tag || GenerationTag.Code);

  //           if (haveCache && JSON.stringify(params) === cachedParams && cache.length > 0) {
  //             setItems(cache.map(getItem));
  //             setOpen(true);
  //             return;
  //           }

  //           const req = type === GenerationTextType.Code
  //             ? API.common.getGenCode
  //             : level === GenerationLevel.Type
  //               ? type === GenerationTextType.Expression ? API.common.genTypeExpressions : API.common.genTypeTemplates
  //               : type === GenerationTextType.Expression ? API.common.genSlotExpressions : API.common.genSlotTemplates;

  //           setLoading(true);
  //           req(params).then((res: any) => {


  //             setItems((res || []).map(getItem));
  //             setOpen(true);

  //             if (res) {
  //               setCache(res);
  //               setCachedParams(JSON.stringify(params));
  //               setHavCache(true);
  //             }

  //           }).catch((reasion: any) => {
  //             message.warning(reasion.message);
  //           }).finally(() => {
  //             setLoading(false);
  //           });
  //         }}
  //       />
  //     </Dropdown>
  //   </div>
  // );
}

function parseSelected(type: GenerationTextType, res: string, paramsStr: any) {
  const params = JSON.parse(paramsStr);

  const idMap: any = {};

  if (params.type) {
    idMap[`[${params.type.label}]`] = type === GenerationTextType.Template ? `$\{${params.type.label}\}` : `$${params.type.id}$`;
  }

  if (params.slot) {
    idMap[`[${params.slot.label}]`] = type === GenerationTextType.Template ? `$\{${params.slot.label}\}` : `$${params.slot.id}$`;
  }

  if (params.slots) {
    for (const slot of params.slots) {
      idMap[`[${slot.label}]`] = type === GenerationTextType.Template ? `$\{${slot.label}\}` : `$${slot.id}$`;
    }
  }

  let tmp = res;
  for (const [k, v] of Object.entries(idMap)) {
    tmp = tmp.replace(k, v as string);
  }

  return tmp;
}

function getParams(level: GenerationLevel, tag: GenerationTag, comment?: string) {
  const path = window.location.pathname;
  const components = path.split('/');


  const result: any = { tag, comment };

  for (let i = 0; i < components.length; i += 1) {
    const comp = components[i];
    if (['intent', 'frame', 'entity', 'service'].findIndex((item: string) => item === comp) !== -1) {

      const typeId = components[i + 1];
      const type = ParameterMapStore.get(typeId);

      result['type'] = {
        label: getFullName(type),
        desc: (type as any).description,

        // for local
        id: type.id
      };

      if (level === GenerationLevel.Type) {
        const slots = type && type.attributes && type.attributes.map((param: ParameterConfig) => ParameterMapStore.get(param.id || ''))
          .filter((param: ParameterConfig) => param.type === ParameterType.ATTRIBUTE)
          .map((param: ParameterConfig) => ({
            label: param.name,
            desc: param.triggers && param.triggers.join(','),
            id: param.id
          }));

        result['slots'] = slots;
      }

    } else if (level === GenerationLevel.Slot && comp === 'slot' && i + 1 < components.length) {
      const slotId = components[i + 1];
      const param = ParameterMapStore.get(slotId);

      if (param && param.name) {
        result['slot'] = {
          label: param.name,
          desc: param && param.triggers && param.triggers.join(','),
          id: slotId
        };
      }
    }
  }

  return result;
}

export const TextGenerator = textGenerator;
